module.exports = __webpack_public_path__ + "img/qrCode.5a85d27a.jpg";